import React from 'react'

export default(props)=>{
  return (
    <section className="hero text-center">
      <div className="container-sm">
        <div className="hero-inner">
          {props.children}
        </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/component/Section.js